<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <!-- <div v-if="loading" class="loader-overlay">
      <div class="loader"></div>
    </div>

    <div v-else></div> -->

    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-sm-7"></div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-4 text-left">
                <h2
                  v-if="editor === 'super-admin' || editor === 'sub-admin'"
                  class="mb-0"
                >
                  Courses
                </h2>
                <h2 v-if="editor === 'company' || editor === 'manager'" class="mb-0">
                  Company Courses
                </h2>
              </div>
              <div class="col-md-8 text-right">
                <base-button class="custom-btn" v-on:click="resetFilters()"
                  ><i class="fa fa-refresh" aria-hidden="true"></i> Clear
                  Filters</base-button
                >
                &nbsp;&nbsp;
                <router-link v-if="canCreate" to="/create_course" class="addnew-course">
                  <base-button class="custom-btn mb-1"
                    ><i class="fa fa-plus" aria-hidden="true"></i> New Course</base-button
                  >
                </router-link>
              </div>
            </div>
          </template>
          <div>
            <div
              class="row mb-2 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-md-7">
                <label>Search:</label>
                <base-input
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search..."
                >
                </base-input>
              </div>
              <div
                class="col-md-2"
                v-if="editor === 'super-admin' || editor === 'sub-admin'"
              >
              <base-input label="Status:">
                <el-select
                  class="select-primary"
                  v-on:change="changePage(1)"
                  v-model="filters.courseStatus"
                  placeholder="Filter by Company Status"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </base-input>
              </div>
              
              <div
                class="col-sm-3"
                v-if="editor === 'super-admin' || editor === 'sub-admin'"
              >
                <label></label>
                <JsonExcel
                  v-if="this.filters.courseStatus === 'Active'"
                  :data="json_data"
                  :exportFields="json_fields"
                  :name="'ActiveCourses.xls'"
                >
                  <base-button class="custom-btn mt-1 w-100">
                    <i class="fas fa-download" aria-hidden="true"></i> Download
                    Excel</base-button
                  >
                </JsonExcel>
                <JsonExcel
                  v-if="this.filters.courseStatus === 'Inactive'"
                  :data="json_data"
                  :exportFields="json_fields"
                  :name="'InactiveCourses.xls'"
                >
                  <base-button class="custom-btn mt-1 w-100">
                    <i class="fas fa-download" aria-hidden="true"></i> Download
                    Excel</base-button
                  >
                </JsonExcel>
                <JsonExcel
                  v-if="this.filters.courseStatus === ''"
                  :data="json_data"
                  :exportFields="json_fields"
                  :name="'AllCourses.xls'"
                >
                  <base-button class="custom-btn mt-1 w-100">
                    <i class="fas fa-download" aria-hidden="true"></i> Download
                    Excel</base-button
                  >
                </JsonExcel>
              </div>
            </div>
            <div class="user-eltable">
              <el-table
                :data="tableData"
                stripe
                highlight-current-row
                row-key="id"
                role="table"
                class="coursesMainGrid"
                header-row-class-name="thead-light custom-thead-light"
                @selection-change="selectionChange"
              >
                <el-table-column
                  v-if="editor === 'super-admin' || editor === 'sub-admin'"
                  label="Name"
                  align="left"
                  property="name"
                  min-width="200px"
                  prop="name"
                  sortable
                >
                  <template slot-scope="props">
                    <span v-if="canEditCourse(props.row)">
                      <router-link :to="'/edit_course?id=' + props.row.id">
                        <span>{{ props.row.name }}</span>
                      </router-link>
                    </span>
                    <span v-else>
                      <span>{{ props.row.name }}</span>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Date Created"
                  property="created_at"
                  align="left"
                ></el-table-column>
                <el-table-column
                  label="Last Modified"
                  property="updated_at"
                  align="left"
                ></el-table-column>
                <el-table-column label="All Users">
                  <div slot-scope="{ row }" class="d-flex custom-size">
                    <i v-if="row.all_users == 1" class="fa fa-check"></i>
                    <i v-if="row.all_users == 0" class="fa fa-times"></i>
                  </div>
                </el-table-column>
                <el-table-column
                  min-width="100px"
                  label="Status"
                  prop="status"
                  v-if="editor === 'super-admin' || editor === 'sub-admin'"
                >
                  <template slot-scope="props">
                    <div
                      class="d-flex"
                      v-on:click="changeStatus(props.$index, props.row)"
                    >
                      <base-switch
                        class="mr-1"
                        v-if="props.row.status"
                        type="success"
                        v-model="props.row.status"
                      ></base-switch>
                      <base-switch
                        class="mr-1"
                        v-else
                        type="danger"
                        v-model="props.row.status"
                      ></base-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column min-width="150px" label="Actions">
                  <div slot-scope="{ row }" class="d-flex custom-size">
                    <el-tooltip v-if="canEditCourse(row)" content="Edit" placement="top">
                      <base-button
                        @click.native="editCourse(row.id)"
                        type=""
                        size="sm"
                        icon
                        data-toggle="tooltip"
                        data-original-title="Edit"
                      >
                        <i class="text-primary fa fa-pencil-square-o"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Assign to Company"
                      placement="top"
                      v-if="
                        (filters.courseStatus === 'Active' && editor === 'super-admin') ||
                        editor === 'sub-admin'
                      "
                    >
                      <base-button
                        type=""
                        size="sm"
                        @click.native="assignCourseToCompany(row.id)"
                        data-toggle="tooltip"
                        data-original-title="Assign to Company"
                      >
                        <i class="text-primary fa fa-building"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Assign to User"
                      placement="top"
                      v-if="filters.courseStatus === 'Active'"
                    >
                      <base-button
                        type=""
                        size="sm"
                        @click.native="assignCourseToUser(row)"
                        data-toggle="tooltip"
                        data-original-title="Assign to User"
                      >
                        <i class="text-primary fa fa-user-plus"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Reassign to User"
                      placement="top"
                      v-if="filters.courseStatus === 'Active'"
                    >
                      <base-button
                        type=""
                        size="sm"
                        @click.native="reassignCourseToUser(row)"
                        data-toggle="tooltip"
                        data-original-title="Reassign to User"
                      >
                        <i class="text-primary fa fa-users"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      content="Duplicate Course"
                      placement="top"
                      v-if="filters.courseStatus === 'Active'"
                    >
                      <base-button
                        type=""
                        size="sm"
                        @click.native="duplicateCourseClickHandler(row)"
                        data-toggle="tooltip"
                        data-original-title="Duplicate Course"
                      >
                        <i class="text-primary fa fa-copy"></i>
                      </base-button>
                    </el-tooltip>
                    <el-tooltip
                      v-if="canEditCourse(row)"
                      content="Delete"
                      placement="top"
                    >
                      <base-button
                        @click.native="deleteCourse(row.id)"
                        type=""
                        size="sm"
                        icon
                        data-toggle="tooltip"
                        data-original-title="Delete"
                      >
                        <i class="text-danger fa fa-trash"></i>
                      </base-button>
                    </el-tooltip>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div slot="footer" class="d-flex justify-content-end">
            <div class="row">
              <div class="col-md-12">
                <ul
                  class="pagination custompagination justify-content-end align-items-center"
                >
                <p class="p-0 m-0 mr-2 d-flex align-items-center">
                    <span class="mr-1">Showing</span>

                    <el-select
                      class="select-primary pagination-select mx-1"
                      v-model="perPage"
                      @change="changePage(1)"
                      placeholder="Per page"
                      size="mini"
                      style="width: auto; display: inline-block;"
                    >
                      <el-option
                        class="select-primary"
                        v-for="item in perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      ></el-option>
                    </el-select>

                    <span class="ml-1">of {{ totalData }} entries</span>
                  </p>
                  <li class="page-item" :class="{ disabled: currentPage === 1 }">
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      ><i class="fa fa-caret-left"></i>
                    </a>
                  </li>
                  <li
                    v-for="(page, index) in pagesNumber"
                    class="page-item"
                    :class="{ active: page == currentPage }"
                    v-bind:key="index"
                  >
                    <a
                      href="javascript:void(0)"
                      @click.prevent="changePage(page)"
                      class="page-link"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{
                      disabled: currentPage === last_page,
                    }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      ><i class="fa fa-caret-right"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <modal :show.sync="assignCourseModel">
      <h3 slot="header">Assign</h3>
      <div class="row">
        <div class="col-md-9">
          <el-select
            style="width: 100%"
            filterable
            multiple
            placeholder="Select Company"
            v-model="assigncompanies"
          >
            <el-option
              v-for="(option, index) in companies"
              class="select-primary"
              :value="option.value"
              :label="option.label"
              :key="'companies' + index"
            >
            </el-option>
          </el-select>
        </div>
        <div class="col-md-3">
          <base-button size="md" @click.prevent="assignCourse(course_id)"
            >Assign</base-button
          >
        </div>
      </div>
      <br />

      <base-button
        class="mt-2 text-right"
        type="danger"
        @click.prevent="reassignCourseToUser"
        >Close</base-button
      >
    </modal>
    <modal :show.sync="reassignToUserModal">
      <h3 slot="header">Select Course Status</h3>
      <div class="row">
        <div
          class="col-md-12"
          v-for="(reassignCourseStatus, index) in reassignCourseStatuses"
        >
          <div class="custom-control custom-checkbox">
            <input
              type="checkbox"
              class="custom-control-input"
              :id="`course-status-${index}`"
              :value="reassignCourseStatus.value"
              v-model="reassignCourseSelectedStatus"
            />
            <label class="custom-control-label" :for="`course-status-${index}`">{{
              reassignCourseStatus.label
            }}</label>
          </div>
        </div>
      </div>
      <div class="row float-right">
        <base-button class="mt-2 text-right" type="danger" @click="reassignCourseToUser"
          >Close</base-button
        >
        <base-button
          class="mt-2 text-right"
          type="success"
          @click.prevent="reassignCourseToUsersModalClickHandler"
          >Reassign</base-button
        >
      </div>
    </modal>
    <modal :show.sync="assignToUserModal">
      <h3 slot="header">Search for the user</h3>
      <div class="row">
        <div class="col-md-12">
          <base-input label="Users">
            <el-select filterable multiple placeholder="Select" v-model="reassignUsers">
              <el-option
                v-for="(user, index) in allUsers"
                class="select-primary"
                :value="user.id"
                :label="`${user.first_name} ${user.last_name} ${
                  user.payroll_id ? ' - ' + user.payroll_id : ''
                }`"
                :key="user.id"
              ></el-option>
            </el-select>
          </base-input>
        </div>
      </div>
      <div class="row float-right">
        <base-button
          class="mt-2 text-right"
          type="danger"
          @click="reassignCourseToSelectedUser"
          >Close</base-button
        >
        <base-button
          class="mt-2 text-right"
          type="success"
          @click.prevent="reassignCourseToSelectedUserClickHandler"
          >Assign</base-button
        >
      </div>
    </modal>
    <modal :show.sync="showUsersWhoAlreadyHaveCourseAssignedModal" size="lg">
      <h3 slot="header">
        This course has already been assigned to the following users. Please click the
        <i class="text-primary fa fa-check"></i> if you would like to reassign to the
        user.
      </h3>
      <div class="row">
        <div class="col-md-12">
          <div class="reassign-data-to-user">
            <el-table
              :data="showUsersWhoAlreadyHaveCourseAssigned"
              class="resourceGrid"
              header-row-class-name="thead-light"
              highlight-current-row
              id="tbl1"
              role="table"
              row-key="id"
              stripe
            >
              <el-table-column label="First Name">
                <template slot-scope="props">
                  {{ props.row.firstName }}
                </template>
              </el-table-column>
              <el-table-column label="Last Name">
                <template slot-scope="props">
                  {{ props.row.lastName }}
                </template>
              </el-table-column>
              <el-table-column label="Employee ID">
                <template slot-scope="props">
                  {{ props.row.employeeId }}
                </template>
              </el-table-column>
              <el-table-column label="Course Status">
                <template slot-scope="props">
                  {{ getCourseStatus(props.row.courseStatus) }}
                </template>
              </el-table-column>
              <el-table-column label="Actions">
                <template slot-scope="props">
                  <el-tooltip content="Assign Course" placement="top">
                    <base-button
                      type=""
                      size="sm"
                      data-toggle="tooltip"
                      data-original-title="Assign to User"
                      @click="assignCourseToSelectedUser(props.row)"
                    >
                      <i class="text-primary fa fa-check"></i>
                    </base-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="row float-right">
        <base-button
          class="mt-2 text-right"
          type="danger"
          @click="showUsersWhoAlreadyHaveCourseAssignedModalCloseHandler"
          >Close</base-button
        >
      </div>
    </modal>
  </div>
</template>
<script>
import { Option, Select, Table, TableColumn } from "element-ui";
//import { BasePagination } from "@/components";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import Swal from "sweetalert2";
import JsonExcel from "vue-json-excel";
import moment from "moment";

let timeout = null;
export default {
  mixins: [serverSidePaginationMixin],
  components: {
    JsonExcel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      loading: false,
      viewCertificateModal: false,
      assignCourseModel: false,
      title: "",
      filters: {
        courseStatus: "Active",
      },
      company_id: "",
      searchQuery: "",
      duplicate: false,
      hot_user: "",
      hot_token: "",
      config: "",
      checked_course: "",
      certificate_Data: [],
      tableData: [],
      selectedRows: [],
      companies: [],
      status: [
        {
          label: "Active",
          value: "Active",
        },
        {
          label: "Inactive",
          value: "Inactive",
        },
        {
          label: "Show All Courses",
          value: "",
        },
      ],
      assigncompanies: "",
      json_fields: {
        "Course Name": "Course Name",
        "# Course ID": "# Course ID",
        "# of lessons": "# of lessons",
        "# of resources": "# of resources",
        "# of companies assigned": "# of companies assigned",
        "# of users assigned": "# of users assigned",
        "# of users completed": "# of users completed",
      },
      json_data: [],
      canCreate: true,
      canEdit: true,
      canDelete: true,
      manager: false,
      reassignToUserModal: false,
      reassignCourseStatuses: [
        {
          label: "Open Course",
          value: 2,
        },
        {
          label: "Failed Course",
          value: 0,
        },
        {
          label: "Expired Course",
          value: 3,
        },
        {
          label: "Passed Course",
          value: 1,
        },
      ],
      reassignCourseSelectedStatus: [2, 0, 3],
      reassignCourse: 0,
      assignToUserModal: false,
      reassignUsers: [],
      allUsers: [],
      showUsersWhoAlreadyHaveCourseAssignedModal: false,
      showUsersWhoAlreadyHaveCourseAssigned: [],
    };
  },
  watch: {
    searchQuery: function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    },
  },
  created() {
    if (localStorage.getItem("hot-token")) {
      this.hot_user = localStorage.getItem("hot-user");
      this.hot_token = localStorage.getItem("hot-token");
    }
    if (localStorage.getItem("hot-user") === "sub-admin") {
      this.getRightsDetails();
    } else if (localStorage.getItem("hot-sidebar") === "manager") {
      this.canCreate = false;
      this.canEdit = false;
      this.canDelete = false;
      this.manager = true;
    }
    if (localStorage.getItem("hot-user") === "employee") {
      this.editor = "employee";
    } else if (localStorage.getItem("hot-user") === "super-admin") {
      this.editor = "super-admin";
    } else if (localStorage.getItem("hot-user") === "sub-admin") {
      this.editor = "sub-admin";
      this.getRightsDetails();
    } else if (localStorage.getItem("hot-user") === "company-admin") {
      this.editor = "company";
    }
    if (localStorage.getItem("hot-sidebar") === "manager") {
      this.editor = "manager";
    }
    if (this.$route.query.id) {
      this.company_id = this.$route.query.id;
    }
    this.setDefaultFilterData();
    this.getAllUser();
  },
  methods: {
    getRightsDetails() {
      let type = "Course";
      this.$http.get("subadmin/subadmin_rights/" + type).then((resp) => {
        this.canCreate = resp.data[0].permissions.indexOf("c") !== -1 ? true : false;
        this.canEdit = resp.data[0].permissions.indexOf("e") !== -1 ? true : false;
        this.canDelete = resp.data[0].permissions.indexOf("d") !== -1 ? true : false;
      });
    },
    cancelAssignCourse() {
      this.assignCourseModel = false;
    },
    assignCourse(course_id) {
      this.$http
        .post("company/assigncourse", {
          course_id: course_id,
          companies: this.assigncompanies,
        })
        .then((resp) => {
          this.assignCourseModel = false;
          Swal.fire({
            title: "Success",
            text: resp.data.message,
            icon: "success",
          });
        })
        .catch(function (error) {
          if (error.response.status === 422) {
            return Swal.fire({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
            });
          }
        });
    },
    assignCourseToCompany(id) {
      this.course_id = id;
      // Start every open with an empty selection so a company picked (or left
      // over) from a previous course does not carry into this one.
      this.assigncompanies = [];
      this.$http
        .post("company/all_companies", {
          company_type: "parent",
          company_status: "Active",
          course_id: this.course_id,
        })
        .then((resp) => {
          this.companies = [];
          let companies = resp.data.companies;
          for (let company of companies) {
            let obj = {
              value: company.id,
              label: company.name,
            };
            this.companies.push(obj);
          }
        });
      this.assignCourseModel = true;
    },
    editCourse(id) {
      this.$router.push("/edit_course?id=" + id);
    },
    deleteCourse(id) {
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            self.$http.delete("/course/delete/" + id, self.config).then((resp) => {
              self.fetchData();
              Swal.fire({
                title: "Deleted!",
                text: "Course has been deleted.",
                icon: "success",
                confirmButtonClass: "btn btn-success btn-fill",
                buttonsStyling: false,
              }).then(function () {});
            });
          }
        })
        .catch(function () {});
    },
    duplicateCourse() {
      if (this.checked_course === "") {
        Swal.fire({
          title: "Error!",
          text: `Please Select Any Course!`,
          icon: "error",
        });
      } else {
        this.$router.push("/create_course?id=" + this.checked_course);
      }
    },
    changeStatus(index, row) {
      let prev_val = row.status;
      let status = "";
      if (prev_val) {
        status = 0;
      } else {
        status = 1;
      }
      let self = this;
      Swal.fire({
        title: "Are you sure?",
        text: "You want to change status!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        buttonsStyling: false,
      })
        .then((result) => {
          if (result.value) {
            self.$http
              .put(
                "/course/update_status/" + row.id,
                {
                  status: status,
                },
                self.config
              )
              .then((resp) => {
                this.fetchData();
                Swal.fire({
                  title: "Success!",
                  text: "Status has been Changed.",
                  icon: "success",
                  confirmButtonClass: "btn btn-success btn-fill",
                  buttonsStyling: false,
                });
                self.tableData[index].status = !prev_val;
              });
          } else {
            self.tableData[index].status = prev_val;
          }
        })
        .catch(function () {
          self.tableData[index].status = prev_val;
        });
    },
    courseCheckchange(row) {
      this.checked_course = row.id;
    },
    fetchData() {
      this.loading = true;
      this.$http
        .post("course/courses_excel", {
          course_status: this.filters.courseStatus,
          company_id: this.company_id,
        })
        .then((resp) => {
          let courses = resp.data.original.courses;
          this.json_data = [];
          for (let course of courses) {
            let row = {
              "Course Name": course.name,
              "# Course ID": course.course_number,
              "# of lessons": course.lessons_count,
              "# of resources": course.resources_count,
              "# of companies assigned": course.companies_count,
              "# of users assigned": course.employees_count,
              "# of users completed": course.passed_employees_count,
            };
            this.json_data.push(row);
          }
        })
        .finally(() => (this.loading = false));

      this.$http
        .post(
          "course/all_courses",
          {
            course_status: this.filters.courseStatus,
            search: this.searchQuery,
            page: this.currentPage,
            column: this.sortedColumn,
            order: this.order,
            per_page: this.perPage,
            company_id: this.company_id,
          },
          this.config
        )
        .then((resp) => {
          this.tableData = [];
          let courses = resp.data.courses;
          this.totalData = resp.data.total;
          for (let course of courses) {
            let obj = {
              id: course.id,
              duplicate: false,
              name: course.name,
              length: course.length,
              cost: course.cost,
              status: true,
              created_at: moment(course.created_at).format("MM-DD-YYYY"),
              updated_at: moment(course.updated_at).format("MM-DD-YYYY"),
              all_users: course.all_users,
              company_specific: course.company_specific,
            };
            if (course.status === 1) {
              obj.status = true;
            } else if (course.status === 0) {
              obj.status = false;
            } else {
              obj.status = course.status;
            }
            this.tableData.push(obj);
          }
        })
        .finally(() => (this.loading = false));
      this.saveSearchData();
    },
    resetFilters() {
      this.company_id = "";
      this.filters.courseStatus = "Active";
      this.searchQuery = "";
      this.fetchData();
    },
    saveSearchData() {
      localStorage.setItem(
        "all_courses_search_data",
        JSON.stringify({
          role: "super-admin",
          course_status: this.filters.courseStatus,
          search: this.searchQuery,
          page: this.currentPage,
          column: this.sortedColumn,
          order: this.order,
          per_page: this.perPage,
          company_id: this.company_id,
        })
      );
    },
    setDefaultFilterData() {
      let previousStateData = JSON.parse(localStorage.getItem("all_courses_search_data"));

      if (previousStateData !== null) {
        this.searchQuery = this.searchQuery ? this.searchQuery : previousStateData.search;
        this.filters.company_id = this.$route.query.id
          ? this.$route.query.id
          : previousStateData.company_id
          ? previousStateData.company_id
          : this.filters.company_id;

        this.filters.courseStatus = previousStateData.course_status
          ? previousStateData.course_status
          : this.filters.courseStatus;
        this.filters.userfilterType = previousStateData.filter_type
          ? previousStateData.filter_type
          : this.filters.userfilterType;
        this.currentPage = previousStateData.page
          ? previousStateData.page
          : this.currentPage;
        this.sortedColumn = previousStateData.column
          ? previousStateData.column
          : this.sortedColumn;
        this.order = previousStateData.order ? previousStateData.order : this.order;
        this.perPage = previousStateData.per_page
          ? previousStateData.per_page
          : this.perPage;
      }
      this.fetchData();
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    canEditCourse: function (course) {
      let canEdit = false;
      if (this.editor == "super-admin" || this.editor == "sub-admin") {
        canEdit = true;
      } else if (this.editor != "super-admin" && course.company_specific != 0) {
        canEdit = true;
      }
      return canEdit;
    },

    assignCourseToUser: function (course) {
      this.reassignCourse = course;
      this.assignToUserModal = true;
    },
    duplicateCourseClickHandler: function (course) {
      this.checked_course = course.id;
      this.duplicateCourse();
    },
    reassignCourseToUser: function (course) {
      this.reassignToUserModal = !this.reassignToUserModal;
      this.reassignCourse = course;
    },
    reassignCourseToUsersModalClickHandler: function () {
      this.loading = true;
      if (this.reassignCourseSelectedStatus.length == 0) {
        this.loading = false;
        Swal.fire({
          title: "Error",
          text: "Select at least one course status to ressign the course to the users",
          icon: "error",
        });
        return true;
      }
      this.loading = true;
      let data = {
        courseId: this.reassignCourse.id,
        courseStatuses: this.reassignCourseSelectedStatus,
      };
      this.$http
        .post("employees/reassign-course-to-user", data)
        .then((resp) => {
          Swal.fire({
            title: "Success",
            text: resp.data.message,
            icon: "success",
          });
          this.loading = this.reassignToUserModal = false;
        })
        .catch((error) => {
          this.loading = this.reassignToUserModal = false;
          Swal.fire({
            title: "Error",
            text: error.response.message,
            icon: "error",
          });
        });
    },
    getAllUser() {
      this.$http.get("employees/get-all-employees").then((resp) => {
        this.allUsers = resp.data.users;
        this.loading = this.reassignToUserModal = false;
      });
    },
    reassignCourseToSelectedUser: function () {
      this.assignToUserModal = !this.assignToUserModal;
      if (this.assignToUserModal == false) {
        this.reassignUsers = [];
      }
    },
    reassignCourseToSelectedUserClickHandler: function () {
      this.loading = true;
      let data = {
        courseId: this.reassignCourse.id,
        reassignUsers: this.reassignUsers,
      };
      this.$http
        .post("employees/assign-course-to-user", data)
        .then((resp) => {
          this.assignToUserModal = false;
          if (resp.data.alreadyAssigned == 0) {
            Swal.fire({
              title: "Success",
              text: resp.data.message,
              icon: "success",
            });
            this.loading = this.reassignToUserModal = false;
          } else if (resp.data.alreadyAssigned > 0) {
            this.showUsersWhoAlreadyHaveCourseAssignedModal = true;
            this.showUsersWhoAlreadyHaveCourseAssigned = resp.data.reAssignTheCourse;
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = this.reassignToUserModal = false;
          Swal.fire({
            title: "Error",
            text: error.response.message,
            icon: "error",
          });
        });
    },
    getCourseStatus: function (status) {
      let name = "";
      switch (status) {
        case 0:
          name = "Failed";
          break;
        case 1:
          name = "Passed";
          break;
        case 2:
          name = "Open";
          break;
        case 3:
          name = "Expired";
          break;
      }
      return name;
    },
    showUsersWhoAlreadyHaveCourseAssignedModalCloseHandler: function () {
      this.showUsersWhoAlreadyHaveCourseAssignedModal = false;
    },
    assignCourseToSelectedUser: function (row) {
      this.loading = true;
      let data = {
        courseId: row.courseId,
        employeeId: row.id,
      };
      this.$http
        .post("employees/assign-course-to-user-again", data)
        .then((resp) => {
          this.showUsersWhoAlreadyHaveCourseAssigned.forEach((selectedUser, index) => {
            if (selectedUser.id == row.id) {
              this.showUsersWhoAlreadyHaveCourseAssigned.splice(index, 1);
            }
          });
          this.loading = false;
        })
        .catch((error) => {
          this.loading = this.reassignToUserModal = false;
          Swal.fire({
            title: "Error",
            text: error.response.message,
            icon: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.no-border-card .card-footer {
  border-top: 0;
}

.custom-size .btn-sm {
  padding: 2px !important;
  font-size: 16px !important;
}

@media only screen and (max-width: 760px),
  (min-device-width: 768px) and (max-device-width: 1024px) {
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(1):before {
    content: "Check";
  }
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(2):before {
    content: "Course Name";
  }
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(3):before {
    content: "Course Length";
  }
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(4):before {
    content: "Allowed Attempts";
  }
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(5):before {
    content: "Status";
  }
  .coursesMainGrid >>> table.el-table__body td:nth-of-type(6):before {
    content: "Actions";
  }
}

.pagination-select {
  display: inline-block !important;
  width: auto !important;
}
.pagination-select >>> .el-input {
  width: auto !important;
}
.pagination-select >>> .el-input__inner {
  width: auto !important;
  padding: 0 20px 0 6px !important;
  height: 28px !important;
  line-height: 28px !important;
  font-size: 13px !important;
  min-width: auto !important;
}
.pagination-select >>> .el-input__suffix {
  right: 5px;
}
</style>
<style lang="scss">
.loader-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  cursor: pointer;
  span.text {
    display: inline-block;
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
  }
  .loader {
    animation: loader-animate 1.5s linear infinite;
    clip: rect(0, 80px, 80px, 40px);
    height: 80px;
    width: 80px;
    position: absolute;
    left: calc(50% - 40px);
    top: calc(50% - 40px);
    &:after {
      animation: loader-animate-after 1.5s ease-in-out infinite;
      clip: rect(0, 80px, 80px, 40px);
      content: "";
      border-radius: 50%;
      height: 80px;
      width: 80px;
      position: absolute;
    }
  }

  @keyframes loader-animate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(220deg);
    }
  }
  @keyframes loader-animate-after {
    0% {
      box-shadow: inset #fff 0 0 0 17px;
      transform: rotate(-140deg);
    }
    50% {
      box-shadow: inset #fff 0 0 0 2px;
    }
    100% {
      box-shadow: inset #fff 0 0 0 17px;
      transform: rotate(140deg);
    }
  }
}



</style>
